import { Query } from "../library/query";
import { UserDTO } from "../models/users";
import { where } from "firebase/firestore";



export class UserRepository {
    private static userCollection = Query.getCollection('users');

    static async getAllUserDetails(): Promise<Array<UserDTO | undefined>> {
        const users = await this.userCollection.getAllDocs();
        const usersDTOArr: Array<UserDTO | undefined> = []
        users.forEach(user => {
            usersDTOArr.push(UserDTO.fromJSON(user))
        })
        return usersDTOArr
    }

    static async getAllUserWithCustomerIds(): Promise<Array<UserDTO | undefined>> {
        const users = await this.userCollection.searchDoc([
            where('customerId', '!=', '')
        ]);

        const usersDTOArr: Array<UserDTO | undefined> = [];
        users.forEach(user => {
            usersDTOArr.push(UserDTO.fromJSON(user));
        });
        return usersDTOArr;
    }

    static async updateUserDetails(userId: string, data: Object): Promise<void> {
        await this.userCollection.updateDocById(userId, { ...data });
    }

    static async getUserDetails(userId: string): Promise<UserDTO | undefined> {
        const user = await this.userCollection.findById(userId);
        return UserDTO.fromJSON(user);
    }

    static async save(user: object) {

    }
}